import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '../components/Login'
import Users from '../components/Users'
import Stations from '../components/Stations'
import StationsThirdParty from '../components/StationsThirdParty'
import Sections from '../components/Sections'
import Questions from '../components/Questions'
import Settings from '../components/Settings'
import Reports from '../components/Reports'
import Report from '../components/Report'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/users',
    name: 'Users',
    component: Users
  },
  {
    path: '/stations',
    name: 'Stations',
    component: Stations
  },
  {
    path: '/stations-third-party',
    name: 'StationsThirdParty',
    component: StationsThirdParty
  },
  {
    path: '/sections',
    name: 'Sections',
    component: Sections
  },
  {
    path: '/questions',
    name: 'PTI Dispatch Library',
    component: Questions
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings
  },
  {
    path: '/reports',
    name: 'LNER Stations - Assessment History',
    component: Reports,
    props: { third: 0 }
  },
  {
    path: '/3rdreports',
    name: 'Third Party Stations - Assessment History',
    component: Reports,
    props: { third: 1 }
  },
  {
    path: '/reports/:id',
    name: 'Report',
    component: Report,
    props: true,
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
